import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

// core components
import SuperAdmin from "layouts/SuperAdmin.js";
import Customers from "layouts/Customers.js";
import Login from "views/Login";
import Return from "views/Return";
import Payment from "views/Admin/Payment";
import AddCardLink from "views/Admin/AddCardLink";
import PaymentResponse from "views/Admin/PaymentResponse";
import PaymentsNotification from "views/Admin/PaymentsNotification";
import PaymentAyasa from "views/Admin/PaymentAyasa";

import NotFoundPage from "views/404";
import RecoveryPassword from "views/RecoveryPassword";
import ProductsPage from "views/ProductsPage";

import "assets/css/material-dashboard-react.css?v=1.8.0";
import { UrlServicesProvider } from "components/UrlServicesContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme();

const hist = createBrowserHistory();

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <UrlServicesProvider>
      <Router history={hist}>
        <Switch>
          <Route path="/" exact={true} component={Return} />
          <Route path="/superadmin" component={SuperAdmin} />
          <Route path="/customers" component={Customers} />
          <Route path="/login" exact={true} component={Login} />
          <Route path="/recovery" exact={true} component={RecoveryPassword} />
          <Route path="/payment" component={Payment} />
          <Route path="/addcard" component={AddCardLink} />
          <Route path="/paymentResponse" component={PaymentResponse} />
          <Route path="/notification" component={PaymentsNotification} />
          <Route path="/products-page" component={ProductsPage} />
          <Route path="/paymentayasa/:slug" component={PaymentAyasa} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Router>
    </UrlServicesProvider>
  </ThemeProvider>,
  document.getElementById("root"),
);
